import { Display } from '../enums';

export default class NavigationUtils {
	static LoaderShow() {
		document.querySelector('body').classList.add('page-loader-show');
		const insertInside = '.page-loader';
		const loaderHtml = `
	<div class="loader-overlay">
		<div class="loader-content">
		<div class="loader-index">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		</div>
	</div>`;

		if (document.querySelectorAll(insertInside).length !== 0) {
			let target = document.querySelector(insertInside);
			if (target) target.insertAdjacentHTML('beforeend', loaderHtml);
		}
	}

	/**
	 * Remove loader
	 */
	static LoaderHide() {
		let el = document.querySelector('.loader-overlay');
		if (!el) return;
		document.querySelector('body').classList.remove('page-loader-show');
		el.parentNode.removeChild(el);
	}

	static createAndOpenPanel(url, reload = false) {
		// Create the overlay
		const overlay = document.createElement('div');
		overlay.id = 'overlay';
		overlay.style.position = 'fixed';
		overlay.style.top = 0;
		overlay.style.left = 0;
		overlay.style.width = '100%';
		overlay.style.height = '100%';
		overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
		overlay.style.zIndex = 2000;

		// Create the panel
		const panel = document.createElement('div');
		panel.id = 'panel';
		panel.style.position = 'fixed';
		panel.style.top = '50%';
		panel.style.left = '50%';
		panel.style.transform = 'translate(-50%, -50%)';
		panel.style.width = '90%';
		panel.style.height = '90%';
		panel.style.backgroundColor = '#fff';
		panel.style.zIndex = 2100;

		// Create the iframe
		const iframe = document.createElement('iframe');
		iframe.src = url;
		iframe.style.width = '100%';
		iframe.style.height = '100%';
		iframe.style.border = 'none';
		iframe.style.display = 'block';
		iframe.style.margin = '0 auto';

		// Create the close button
		const closeButton = document.createElement('div');
		closeButton.id = 'close-popup';
		closeButton.className = 'btn-default btn btn-floating back-link';
		closeButton.title = 'Chiudi';
		closeButton.setAttribute('data-toggle', 'tooltip');
		closeButton.setAttribute('data-original-title', 'Chiudi');

		const closeIcon = document.createElement('i');
		closeIcon.className = 'icon fa-solid fa-xmark';
		closeIcon.setAttribute('aria-hidden', 'true');

		closeButton.appendChild(closeIcon);
		closeButton.style.position = 'absolute';
		closeButton.style.top = '5px';
		closeButton.style.left = '5px';
		closeButton.style.width = '3rem';
		closeButton.style.height = '3rem';
		closeButton.style.cursor = 'pointer';
		closeButton.style.color = '#76838f !important';

		// Loader inside the panel while iframe loads
		const panelLoader = document.createElement('div');
		panelLoader.className = 'loader-overlay';
		panelLoader.innerHTML = '<div class="loader-content"><div class="loader-index"><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
		panelLoader.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#fff;z-index:3';
		panel.style.overflow = 'hidden';
		panel.appendChild(panelLoader);

		iframe.addEventListener('load', () => {
			// Remove the iframe's own page loader to avoid the double
			try {
				const iframeBody = iframe.contentDocument?.body;
				if (iframeBody) {
					iframeBody.classList.remove('page-loader-show');
					const iframeLoader = iframeBody.querySelector('.loader-overlay');
					if (iframeLoader) iframeLoader.remove();
				}
			} catch (e) {}
			panelLoader.remove();
		});

		// Append elements
		panel.appendChild(iframe);
		panel.appendChild(closeButton);
		overlay.appendChild(panel);
		document.body.appendChild(overlay);

		function closePopup() {
			document.body.removeChild(overlay);
			window.dispatchEvent(new CustomEvent('popup-closed'));
			if (reload) {
				window.location.reload();
			} else {
				console.info('Chiusura comunicazione con popup');
				window.removeEventListener('message', messageHandler);
			}
		}

		function messageHandler(event) {
			if (event.data === 'allowClose' || event.data === 'preventClose') {
				if (event.data === 'allowClose') {
					closePopup();
				} else if (event.data === 'preventClose') {
					bootbox.confirm({
						message: 'Potrebbe esserci del lavoro non salvato. Sei sicuro di voler chiudere la pagina?',
						callback: function (result) {
							if (result) {
								iframe.contentWindow.postMessage({ action: 'setNeedsConfirm', value: false }, '*');
								iframe.contentWindow.postMessage('requestClose', '*');
							}
						},
					});
				}
			} else if (event.data === 'ping') {
				console.info('handshake window/popup effettuato');
				iframe.contentWindow.postMessage('pong', '*');
			} else if (event.data === 'changelogRead') {
				setLastVersion(window.version);
				checkForUpdates();
			}
		}

		window.addEventListener('message', messageHandler);

		console.info('Inizializzato protocollo richiesta requestClose');

		closeButton.addEventListener('click', function () {
			iframe.contentWindow.postMessage('requestClose', '*');
		});
	}

	static openUrlInOffcanvas(url, title = null) {
		if (url) {
			url = new URL(url);
			url.searchParams.set('popup', 'true');
			if (!url.searchParams.get('display')) {
				url.searchParams.set('display', Display.CARD_ESSENTIAL);
			}
			url = url.toString();
		}
		document.dispatchEvent(new CustomEvent('openOffcanvas', { detail: { data: { action: url ? 'iframe' : 'empty', url, title } } }));
	}

	static getProxyStreamUrl(url) {
		return window.appconfig.routes.files.stream + '?proxyurl=' + btoa(url);
	}
}
